<template>
    <!-- 外層容器：仍保留聯絡我們的 3D + 淡入風格 -->
    <div class="profile-container" ref="profileBlock">
        <!-- 單一卡片 -->
        <div class="profile-card single-column">
            <!-- 標題 & 簡介 -->
            <div class="profile-header">
                <h1>會員資料</h1>
                <p>在此可以直接查看與修改您的基本資訊。</p>
            </div>
            <!-- 表單 -->
            <form class="profile-edit-form" @submit.prevent="updateProfile">
                <!-- 會員編號 & 會員帳號 (水平兩欄) -->
                <div class="form-group horizontal">
                    <div class="field-block">
                        <label for="user_id">會員編號</label>
                        <input id="user_id" type="text" v-model="userProfile.user_id" disabled />
                    </div>
                    <div class="field-block">
                        <label for="account">會員帳號 / 第三方登入</label>
                        <!-- 一般帳號 -->
                        <input v-if="userProfile.account" type="text" :value="userProfile.account" disabled />
                        <!-- facebook -->
                        <input v-if="userProfile.facebook_id" type="text" value="是使用 Facebook 成為會員" disabled />
                        <!-- google -->
                        <input v-if="userProfile.google_id" type="text" value="是使用 Google 成為會員" disabled />
                        <!-- line -->
                        <input v-if="userProfile.line_user_id" type="text" value="是使用 LINE 成為會員" disabled />
                        <!-- 如果全部都沒有，就顯示一個預設文字 -->
                        <input
                            v-if="!userProfile.account && !userProfile.facebook_id && !userProfile.google_id && !userProfile.line_user_id"
                            type="text" value="尚未綁定任何會員帳號" disabled />
                    </div>
                </div>

                <!-- E-Mail & 手機號碼 (水平兩欄 + attached-wrapper) -->
                <div class="form-group horizontal">
                    <!-- E-Mail -->
                    <div class="field-block">
                        <label for="email">E-Mail</label>
                        <div class="attached-wrapper">
                            <input id="email" type="text" v-model="userProfile.email" disabled />
                            <button type="button" class="change-btn-attached" @click="openChangeModal('email')">
                                {{userProfile.email ? '變更' : '新增'}}
                            </button>
                        </div>
                    </div>

                    <!-- 手機號碼 -->
                    <div class="field-block">
                        <label for="phone">手機號碼</label>
                        <div class="attached-wrapper">
                            <input id="phone" inputmode="numeric" type="text" v-model="userProfile.phone" disabled />
                            <button type="button" class="change-btn-attached" @click="openChangeModal('phone')">
                                {{userProfile.phone ? '變更' : '新增'}}
                            </button>
                        </div>
                    </div>
                </div>

                <!-- 姓名 (單欄) -->
                <div class="form-group">
                    <label for="username">會員姓名</label>
                    <input id="username" type="text" v-model="userProfile.username" placeholder="請輸入會員姓名" />
                </div>

                <!-- 性別 & 生日 (水平兩欄) -->
                <div class="form-group horizontal">
                    <div class="gender-radio-toggle">
                        <label class="radio-btn" :class="{ active: userProfile.gender === 'male' }">
                            <input type="radio" value="male" v-model="userProfile.gender" />
                            男性
                        </label>
                        <label class="radio-btn" :class="{ active: userProfile.gender === 'female' }">
                            <input type="radio" value="female" v-model="userProfile.gender" />
                            女性
                        </label>
                        <label class="radio-btn" :class="{ active: userProfile.gender === '' }">
                            <input type="radio" value="" v-model="userProfile.gender" />
                            不透露
                        </label>
                    </div>

                    <div class="field-block">
                        <label for="birthday">生日</label>
                        <input type="date" v-model="userProfile.birthday" :locale="locale" format="yyyy-MM-dd"
                            :translation="false" :max-date="new Date()" select-text="確定" cancel-text="取消" />
                        
                        <!-- <Datepicker v-model="userProfile.birthday" :locale="locale" format="yyyy-MM-dd"
                            :translation="false" :max-date="new Date()" select-text="確定" cancel-text="取消" /> -->

                    </div>
                </div>
                <!-- 錯誤訊息顯示 -->
                <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
                <!-- 提交按鈕 -->
                <button type="submit" class="submit-btn">{{ isSending ? '更新中...' : '更新' }}</button>
            </form>
        </div>

        <!-- === 彈跳視窗 (Modal) === -->
        <div v-if="showChangeModal" class="modal-mask">
            <div class="modal-wrapper" @click.stop>
                <div class="modal-container">
                    <!-- 標題：根據 modalType 顯示不同文案 -->
                    <div class="modal-header">
                        <h3>
                            變更
                            <span v-if="modalType === 'email'">Email</span>
                            <span v-else>手機</span>
                        </h3>
                        <!-- 步驟指示器 -->
                        <div class="modal-step-indicator">
                            <div class="step-item" :class="{ active: modalStep === 1 }">
                                <span class="step-number">1</span>
                                <span v-if="modalType === 'email'">輸入新 Email</span>
                                <span v-else>輸入新手機</span>
                            </div>
                            <div class="step-item" :class="{ active: modalStep === 2 }">
                                <span class="step-number">2</span> 輸入驗證碼
                            </div>
                        </div>
                    </div>

                    <!-- 如果是 Email 流程 -->
                    <div v-if="modalType === 'email'">
                        <!-- 步驟 1：輸入新 Email -->
                        <div v-if="modalStep === 1">
                            <div class="form-group">
                                <label>新 Email</label>
                                <input type="text" v-model="newEmail" placeholder="請輸入新 Email" />
                            </div>
                            <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>

                            <button class="verify-btn" :disabled="isSending" @click="sendVerificationCodeEmail">
                                {{ isSending ? '發送中...' : '發送驗證碼' }}
                            </button>
                            <button class="cancel-btn" @click="closeChangeModal">取消</button>
                        </div>

                        <!-- 步驟 2：Email 驗證碼 -->
                        <div v-else>
                            <div class="form-group">
                                <label>驗證碼</label>
                                <input type="text" inputmode="numeric" v-model="verificationCode" placeholder="請輸入驗證碼" />
                            </div>
                            <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>

                            <button class="verify-btn" @click="verifyCodeEmail">
                                {{ isSending ? '驗證中...' : '驗證並更新' }}
                            </button>
                            <button class="cancel-btn" @click="closeChangeModal">取消</button>
                        </div>
                    </div>

                    <!-- 如果是 Phone 流程 -->
                    <div v-else>
                        <!-- 步驟 1：輸入新手機 -->
                        <div v-if="modalStep === 1">
                            <div class="form-group">
                                <label>新手機</label>
                                <input type="text" inputmode="numeric" v-model="newPhone" placeholder="請輸入新的手機號碼" />
                            </div>
                            <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>

                            <button class="verify-btn" :disabled="isSending" @click="sendVerificationCodePhone">
                                {{ isSending ? '發送中...' : '發送驗證碼' }}
                            </button>
                            <button class="cancel-btn" @click="closeChangeModal">取消</button>
                        </div>

                        <!-- 步驟 2：手機驗證碼 -->
                        <div v-else>
                            <div class="form-group">
                                <label>驗證碼</label>
                                <input type="text" inputmode="numeric" v-model="phoneVerificationCode" maxlength="6" name="no-autofill"
                                    placeholder="請輸入驗證碼" />
                            </div>
                            <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>

                            <button class="verify-btn" @click="verifyCodePhone">
                                {{ isSending ? '驗證中...' : '驗證並更新' }}
                            </button>
                            <button class="cancel-btn" @click="closeChangeModal">取消</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- === 彈跳視窗結束 === -->
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import axios from 'axios';
import Swal from 'sweetalert2';

/* 1) 引入 Vue 3 Datepicker + CSS */
//import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import zhTw from 'element-plus/dist/locale/zh-tw.mjs'

export default {
    name: "ProfilePage",
    //components: { Datepicker },
    data() {
        return {
            locale: zhTw,
            showChangeModal: false,
            modalType: "",   // 'email' or 'phone'
            modalStep: 1,
            isSending: false,

            // Email flow
            newEmail: "",
            verificationCode: "",

            // Phone flow
            newPhone: "",
            phoneVerificationCode: "",

            errorMessage: "",
        };
    },
    computed: {
        ...mapState(['userProfile','redirectPath']),
    },
    mounted() {
        // IntersectionObserver：加淡入 & 3D翻轉
        const container = this.$refs.profileBlock;
        const observer = new IntersectionObserver(
            (entries, obs) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("container-visible");
                        obs.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.1 }
        );
        observer.observe(container);

        window.addEventListener('keydown', this.handleEscKey);
    },
    beforeUnmount() {
        window.removeEventListener('keydown', this.handleEscKey);
    },
    methods: {
        ...mapMutations(['setUserProfile', 'setRedirectPath']),

        handleEscKey(e) {
            if (e.key === 'Escape' && this.showChangeModal) {
                this.closeChangeModal();
            }
        },
        async updateProfile() {

            if(!this.userProfile.email){
                this.errorMessage = "請輸入Email！";
                return;
            }

            if(!this.userProfile.phone){
                this.errorMessage = "請輸入手機號碼！";
                return;
            }

            // 檢查姓名 & 生日
            if (!this.userProfile.username) {
                this.errorMessage = "請輸入姓名！";
                return;
            }

            this.userProfile.username = this.userProfile.username.trim();

            if (!/^[\u4e00-\u9fa5]+$/.test(this.userProfile.username)) {
                this.errorMessage = '會員姓名須為中文！';
                return;
            }

            // if (!this.userProfile.birthday) {
            //     this.errorMessage = "請選擇生日！";
            //     return;
            // }

          //  console.log(this.userProfile.birthday)

            let dateString = null;
            if(this.userProfile.birthday){
                const dateObj = new Date(this.userProfile.birthday);
                const yyyy = dateObj.getFullYear();
                const mm = String(dateObj.getMonth() + 1).padStart(2, '0'); // 月份從 0 開始
                const dd = String(dateObj.getDate()).padStart(2, '0');
                dateString = `${yyyy}-${mm}-${dd}`;
            }
           
            // dateString 會是 '2025-01-03' 這樣的格式


            // 清空錯誤訊息
            this.errorMessage = "";

            try {
                // 將前端 userProfile 送至後端
                const res = await axios.post('/api/user/updateUser', {
                    // 您要傳什麼欄位，就寫什麼
                    user_id: this.userProfile.user_id,
                    username: this.userProfile.username,
                    gender: this.userProfile.gender,
                    birthday: dateString,
                });
                // 後端回傳成功 or 失敗
                if (res.data.success) {
                    // 如果後端表示更新成功
                    this.setUserProfile(this.userProfile);
                    Swal.fire({
                        icon: 'success',
                        title: '更新成功！',
                        text: '您的會員資料已更新完成',
                        confirmButtonText: '確定',
                        timer: 2000
                    });
                    if (this.redirectPath) {
                        this.$router.push(this.redirectPath)
                        this.setRedirectPath(null)
                    }
                } else {
                    // 如果後端回傳 success:false, 顯示錯誤
                    this.errorMessage = res.data.message || '更新失敗，請稍後再試';
                }
            } catch (err) {
                // 若 axios 發生例外
                console.error(err);
                this.errorMessage = err.response?.data?.message || '伺服器錯誤，請稍後再試';
            }
        },

        // 打開彈窗
        openChangeModal(type) {
            this.showChangeModal = true;
            this.modalType = type;
            this.modalStep = 1;
            this.isSending = false;
            this.errorMessage = "";

            // 清空對應欄位
            if (type === 'email') {
                this.newEmail = "";
                this.verificationCode = "";
            } else {
                this.newPhone = "";
                this.phoneVerificationCode = "";
            }
        },
        closeChangeModal() {
            this.showChangeModal = false;
            this.modalType = "";
            this.modalStep = 1;
            this.isSending = false;
            this.errorMessage = "";

            this.newEmail = "";
            this.verificationCode = "";
            this.newPhone = "";
            this.phoneVerificationCode = "";
        },

        // ========== Email 流程 ==========
        async sendVerificationCodeEmail() {
            if (!this.newEmail) {
                this.errorMessage = "請輸入新 Email";
                return;
            }
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(this.newEmail)) {
                this.errorMessage = "Email 格式不正確";
                return;
            }
            if (this.userProfile.email === this.newEmail) {
                this.errorMessage = "無法與當前 Email 相同";
                return;
            }

            this.errorMessage = "";
            this.isSending = true;
            try {
                const res = await axios.post('/api/email/send-code', { email: this.newEmail });
                if (!res.data.success) {
                    this.errorMessage = (res.data.message || '發送驗證碼失敗');
                    return;
                }
                this.modalStep = 2;
            } catch (err) {
                this.errorMessage = err.response?.data?.message || '發送驗證碼失敗';
            } finally {
                this.isSending = false;
            }
        },

        async verifyCodeEmail() {
            if (!this.verificationCode) {
                this.errorMessage = "請輸入驗證碼";
                return;
            }
            this.errorMessage = "";
            this.isSending = true;
            try {
                const res = await axios.post('/api/user/updateEmail', {
                    user_id: this.userProfile.user_id,
                    email: this.newEmail,
                    code: this.verificationCode
                });
                if (!res.data.success) {
                    this.errorMessage = (res.data.message || '驗證失敗');
                    return;
                }
                // 成功 → 更新
                this.userProfile.email = this.newEmail;
                this.setUserProfile(this.userProfile);

                Swal.fire({
                    icon: 'success',
                    title: 'Email 變更成功！',
                    text: '您的 Email 已更新完成',
                    confirmButtonText: '確定',
                    timer: 2000
                });
                this.closeChangeModal();
            } catch (err) {
                this.errorMessage = err.response?.data?.message || '驗證失敗';
            } finally {
                this.isSending = false;
            }
        },

        // ========== Phone 流程 ==========
        async sendVerificationCodePhone() {
            if (!this.newPhone) {
                this.errorMessage = "請輸入新的手機號碼";
                return;
            }
            // 檢查手機格式
            const taiwanPhoneRegex = /^09\d{8}$/;
            const internationalPhoneRegex = /^\+\d{1,4}\s?\d{6,12}$/;
            if (!taiwanPhoneRegex.test(this.newPhone) && !internationalPhoneRegex.test(this.newPhone)) {
                this.errorMessage = "手機號碼格式不正確";
                return;
            }
            if (this.userProfile.phone === this.newPhone) {
                this.errorMessage = "無法與當前手機相同";
                return;
            }

            this.errorMessage = "";
            this.isSending = true;
            try {
                const res = await axios.post('/api/phone/sendcode', { phone: this.newPhone });
                if (!res.data.success) {
                    this.errorMessage = (res.data.message || '發送驗證碼失敗');
                    return;
                }
                this.modalStep = 2;
            } catch (err) {
                this.errorMessage = err.response?.data?.message || '發送驗證碼失敗';
            } finally {
                this.isSending = false;
            }
        },

        async verifyCodePhone() {
            if (!this.phoneVerificationCode) {
                this.errorMessage = "請輸入驗證碼";
                return;
            }
            this.errorMessage = "";
            this.isSending = true;
            try {
                const res = await axios.post('/api/user/updatePhone', {
                    user_id: this.userProfile.user_id,
                    phone: this.newPhone,
                    code: this.phoneVerificationCode
                });
                if (!res.data.success) {
                    this.errorMessage = (res.data.message || '驗證失敗');
                    return;
                }
                // 成功 → 更新
                this.userProfile.phone = this.newPhone;
                this.setUserProfile(this.userProfile);

                Swal.fire({
                    icon: 'success',
                    title: '手機 變更成功！',
                    text: '您的 手機 已更新完成',
                    confirmButtonText: '確定',
                    timer: 2000
                });
                this.closeChangeModal();
            } catch (err) {
                this.errorMessage = err.response?.data?.message || '驗證失敗';
            } finally {
                this.isSending = false;
            }
        }
    }
};
</script>

<style scoped>
/* === 基本容器: 3D淡入效果 === */
.profile-container {
    overflow-x: hidden;
    width: 50%;
    margin: 0 auto;
    padding: 20px;
    opacity: 0;
    transform: translateY(50px) rotateX(8deg);
    transform-origin: top;
    transition: opacity 1.2s ease, transform 1.2s ease;
    perspective: 800px;
    /* 父容器3D視角 */
}

.profile-container.container-visible {
    opacity: 1;
    transform: translateY(0) rotateX(0);
}

/* === 卡片樣式 === */
.profile-card {
    background-color: #f9f9f9;
    border-radius: 10px;
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
    padding: 30px;
    /* 預設淡出下移 */
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.8s ease, transform 0.8s ease;
}

.container-visible .profile-card {
    opacity: 1;
    transform: translateY(0);
}

/* 單欄式 */
.single-column {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

/* 標題 & 簡介 */
.profile-header {
    text-align: center;
}

.profile-header h1 {
    font-size: 2rem;
    margin-bottom: 10px;
}

.profile-header p {
    line-height: 1.6;
    font-size: 1rem;
    color: #666;
}

/* 表單 */
.profile-edit-form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

/* 每個欄位 */
.form-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.form-group label {
    font-weight: bold;
    margin-bottom: 5px;
}

.form-group input {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 100%;
    box-sizing: border-box;
}

/* 水平排列兩欄: E-Mail & Phone, Gender & Birthday 等 */
.form-group.horizontal {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1rem;
}

.field-block {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.field-block label {
    font-weight: bold;
    margin-bottom: 5px;
}

.field-block input,
.field-block select {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-sizing: border-box;
    width: 100%;
}

/* 合體式 Input + Button (attached-wrapper) */
.attached-wrapper {
    display: inline-flex;
    align-items: stretch;
    border: 1px solid #ccc;
    border-radius: 5px;
    overflow: hidden;
    width: 100%;
}

.attached-wrapper input {
    border: none;
    outline: none;
    flex: 1;
    padding: 10px 14px;
    min-width: 0;
    box-sizing: border-box;
}

.change-btn-attached {
    border: none;
    background-color: #3498db;
    color: #fff;
    padding: 10px 16px;
    cursor: pointer;
    font-size: 1rem;
    line-height: normal;
    transition: background-color 0.2s ease;
}

.change-btn-attached:hover {
    background-color: #2980b9;
}

/* 提交按鈕 (更新) */
.submit-btn {
    display: inline-block;
    padding: 10px 20px;
    background-color: #27ae60;
    color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transform: scale(1.05);
}

.submit-btn:hover {
    background-color: #0a7e3a;
    transform: scale(1.00);
}

/* === Modal === */
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-wrapper {
    width: 90%;
    max-width: 500px;
}

.modal-container {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    animation: modal-fade-in 0.3s ease;
}

@keyframes modal-fade-in {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Modal 內按鈕 */
.verify-btn,
.cancel-btn {
    margin: 10px 5px 0 0;
    padding: 8px 14px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.verify-btn {
    background-color: #27ae60;
    color: #fff;
}

.verify-btn:hover {
    background-color: #2ecc71;
}

.cancel-btn {
    background-color: #ccc;
    color: #333;
}

.cancel-btn:hover {
    background-color: #bbb;
}

/* Error message */
.error-message {
    color: red;
    margin-top: 4px;
}

/* modal-header (步驟指示) */
.modal-header {
    margin-bottom: 16px;
}

.modal-step-indicator {
    display: flex;
    gap: 8px;
    margin-top: 10px;
}

.step-item {
    display: flex;
    align-items: center;
    color: #999;
    font-size: 1rem;
}

.step-number {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    background-color: #ccc;
    color: #fff;
    border-radius: 50%;
    margin-right: 5px;
}

.step-item.active {
    color: #007bff;
    font-weight: bold;
}


.step-item.active .step-number {
    background-color: #007bff;
}

.gender-radio-toggle {
    display: inline-flex;
    gap: 0.5rem;
}

/* 隱藏原生 radio */
.gender-radio-toggle input[type="radio"] {
    position: absolute;
    opacity: 0;
    pointer-events: none;
}

/* 模擬按鈕 */
.radio-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    cursor: pointer;
    user-select: none;
    transition: background-color 0.2s, border-color 0.2s;
}

.radio-btn.active {
    background-color: #3498db;
    /* 主色 */
    color: #fff;
    border-color: #2980b9;
    /* 深一些的邊框色 */
}


/* RWD: 小於 850px 時, 全寬 & 垂直排列 */
@media (max-width: 850px) {
    .profile-container {
        width: 90%;
    }

    .form-group.horizontal {
        flex-direction: column;
    }

    .attached-wrapper {
        flex-direction: column;
    }

    .change-btn-attached {
        border-top: 1px solid #ccc;
        border-radius: 0;
    }
}

/* 文字 */
/* @media (max-width: 768px) {

    h1 {
        font-size: 2.0rem;
    }

    h2 {
        font-size: 1.8rem;
    }

    h3 {
        font-size: 1.5rem;
    }

    .step-indicator {
        font-size: 1.05rem;
    }

    label {
        font-size: 1.5rem;
    }

    input {
        font-size: 1.5rem;
    }

    button {
        font-size: 1.5rem;
    }

    .error-message {
        font-size: 1.25rem;
    }

    p {
        font-size: 1.25rem;
    }
} */
</style>
